// Espejo de server/utils/purchaseItemCalc.js — mantener iguales.
// Renglón de compra: costo de LISTA del proveedor, % de descuento, y el neto
// efectivo (unitCost) que es lo que de verdad cuesta y va al producto.
const redondear = (n: number) => Math.round((Number(n) || 0) * 100) / 100;

export function calcularItemCompra(p: { quantity: number; listCost: number; discountPct: number; taxRate: number }) {
  const qty = Number(p.quantity) || 0;
  const lista = Number(p.listCost) || 0;
  const desc = Math.min(100, Math.max(0, Number(p.discountPct) || 0));
  const iva = Number(p.taxRate) || 0;
  const unitCost = redondear(lista * (1 - desc / 100));
  const subtotal = redondear(qty * unitCost);
  const taxAmount = redondear(subtotal * (iva / 100));
  return { unitCost, subtotal, taxAmount, total: redondear(subtotal + taxAmount) };
}

/** Costo c/IVA tipeado a mano → costo de lista (deshace IVA y descuento). */
export function listaDesdeCostoConIva(p: { grossUnit: number; discountPct: number; taxRate: number }) {
  const desc = Math.min(100, Math.max(0, Number(p.discountPct) || 0));
  const iva = Number(p.taxRate) || 0;
  const neto = (Number(p.grossUnit) || 0) / (1 + iva / 100);
  if (desc >= 100) return 0;
  return redondear(neto / (1 - desc / 100));
}
